/**
 * EventView view component.
 * @module components/theme/View/EventView
 */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { hasBlocksData, flattenHTMLToAppURL } from '@plone/volto/helpers';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';

import config from '@plone/volto/registry';
import { injectIntl } from 'react-intl';
import FadeInSection from "../../theme/Animations/FadeInSection"
import { Image } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';


/**
 * EventView view component class.
 * @function EventView
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const EventView = (props) => {
  const { content } = props;

  const [elemWidth, setelemWidth] = useState("twelve")

  useEffect(() => {
    if (content.supporters?.length % 2 === 0) {
      setelemWidth("six")
    }

     if (content.supporters?.length % 3 === 0) {
      setelemWidth("four")
    }

     if (content.supporters?.length % 4 === 0) {
      setelemWidth("three")
    }


  })


  const Container =
    config.getComponent({ name: 'Container' }).component || SemanticContainer;
  const dateOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };

  return (
    <div id="page-document" className="view-wrapper event-view">
      {hasBlocksData(content) &&
        <>
          <RenderBlocks {...props} />
        </>
      }
      {(content.supporters && content.supporters.length > 0) && (
        <FadeInSection>
          <div className="event-foerderer-block">
            <div className='event-container'>
              <h2>Mit freundlicher Unterstützung</h2>
              <div className='ui twelve column grid column-grid icons'>
                {content.supporters.map((icon, index) => (
                    <div className={`three wide computer twelve wide mobile six wide tablet column tile`} key={index}>
                      <div className='tile-content'>
                        {console.log(icon['@id'] + '/@@images/image')}
                        {console.log(elemWidth)}
                        {icon && <Image src={flattenToAppURL(icon['@id'] + '/@@images/image')} alt={icon?.alt ? icon.alt : null} />}
                      </div>
                    </div>
                ))}
              </div>
            </div>
          </div>
        </FadeInSection>
      )}
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
EventView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    text: PropTypes.shape({
      data: PropTypes.string,
    }),
    attendees: PropTypes.arrayOf(PropTypes.string).isRequired,
    contact_email: PropTypes.string,
    contact_name: PropTypes.string,
    contact_phone: PropTypes.string,
    end: PropTypes.string.isRequired,
    event_url: PropTypes.string,
    location: PropTypes.string,
    open_end: PropTypes.bool,
    recurrence: PropTypes.any,
    start: PropTypes.string.isRequired,
    subjects: PropTypes.arrayOf(PropTypes.string).isRequired,
    whole_day: PropTypes.bool,
  }).isRequired,
};
export default injectIntl(EventView);
